export default "__VITE_ASSET__42964bc9__"